import API from './request'; // 加载平台接口封装
export const commonServer = {
  // 获取用户基本信息
  getUserInfo: (params) => API.get('/user/info', params),
  // 更新用户语言
  updateUserLang: () => API.post('/user/updateUserLang'),
  // 获取用户的权限信息
  getRouterAuth: () => API.get(`/user/permission/router/auth/list`),
  // 退出
  signOut: (params) => API.get('/user/ticket', params),
  // 获取预览文件链接
  getPreviewUrl: (params) => API.get(`/file/url/${params}`),
  // 获取文件上传token
  getFileToken: (params) => API.get('/file/token', params),
  // 切换用户
  getImitateUser: ({ userName, type }) => API.get(`/user/imitate/${userName}/${type}`),
  // 切换角色
  switchRole: (params) => API.get(`/user/role/switch/${params}`),
  // 获取预览文件链接
  getAddressList: (params) => API.get(`/gift/option${params}`),
  // 获取代办数量
  getPendingQuantity: () => API.get(`/approvecenter/wait_tasks_count`),
  // 获取ticketEncrypt
  getTicketEncrypt: () => API.get(`/ht/ticketEncrypt`)
};

export const qdSignContractApi = {
  // 获取签约状态及基本信息
  getQdSignContractInfo: (params) => API.get(`/signature/qd/info/${params}`),
  // 填充pdf文档
  setPdfDocument: (params) => API.post('/signature/pdf', params),
  // 电子签章
  signatureSubmit: (params) => API.post(`/signature/submit/${params}`),
  // 获取文件服务器中的填充文档
  getPdfUrl: (params) => API.get(`/signature/pdf/${params}`),
  // 获取签约后文件
  getSigningAfterFile: (params) => API.get(`/signature/contract/${params}`),
  // 获取签约协议
  getQdElectronicSignature: (params) => API.get('/agreement/content/QdElectronicSignature')
};
